<template>
<div class="MyActivityList">
</div>
</template>

<script>
export default {
    name: 'MyActivityList',
    data() {
        return {}
    },
    mounted() {
    },
    methods: {},
    filters: {},
    watch: {},
    computed: {},
    components: {}
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
.MyActivityList {
}
</style>
